import {
  Box,
  ClickAwayListener,
  Divider,
  Menu,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import Quill, { DeltaStatic, Sources } from "quill";
import { forwardRef, useEffect, useRef, useState } from "react";
import ReactQuill, { ReactQuillProps } from "react-quill";
import { extractStringFromHtml } from "utilz/helpers";
import { v4 } from "uuid";
import QuillToolBar from "./quillToolbar";

interface QuillEditorProps extends Omit<ReactQuillProps, "onChange"> {
  name?: string;
  onChange: (
    { field, value }: { field: string; value: string },
    meta?: {
      value: string;
      delta: DeltaStatic;
      source: Sources;
      editor: ReactQuill.UnprivilegedEditor;
    },
  ) => void;
  isRequired?: boolean;
  error?: boolean;
  errorMessage?: string;
  showToolbar?: boolean;
  maxHeight?: string; // New prop to control max height
  minHeight?: string;
}

const Delta = Quill.import("delta");
const CustomQuillEditor = forwardRef(
  ({ onChange, onBlur, ...props }: QuillEditorProps, customRef: any) => {
    const [open, setOpen] = useState(false);
    const onChangeHandler = (
      value: string,
      delta: DeltaStatic,
      source: Sources,
      editor: ReactQuill.UnprivilegedEditor,
    ) => {
      onChange(
        {
          field: props.name || "",
          value: extractStringFromHtml(value).length > 0 ? value : "",
        },
        {
          value,
          delta,
          source,
          editor,
        },
      );
    };

    return (
      // <ReactQuill theme="snow" value={value} onChange={onChangeHandler} />
      <Box
        sx={{
          width: "100%",
          // height: "100%",
          // height: 'inherit',
          flexDirection: "column",
          // "& .ql-editor": {
          //   height: "300px",
          //   // height: "100%",
          //   flex: 1,
          //   // maxHeight: "100%",
          //   overflow: "clip",
          //   border: props.error ? "1px solid #EF4C54" : "1px solid #EDEDED",
          //   padding: "16px",
          //   margin: props?.error ? "8px 16px 16px 16px" : "16px",
          //   backgroundColor: "#F6F6F5",
          //   borderRadius: "4px",
          // },
          //modified height
          "& .ql-editor": {
            // Improved height and scrolling
            flex: 1,
            minHeight: props?.minHeight || "300px", //Dynamic Minimum height
            maxHeight: props?.maxHeight || "300px", // Dynamic max height
            height: "auto", // Allow dynamic height
            overflowY: "auto", // Enable vertical scrolling
            wordBreak: "break-word", // Break long words
            whiteSpace: "pre-wrap", // Wrap text
            border: props.error ? "1px solid #EF4C54" : "1px solid #EDEDED",
            padding: "16px",
            margin: props?.error ? "8px 16px 16px 16px" : "16px",
            backgroundColor: "#F6F6F5",
            borderRadius: "4px",
          },
          "& .ql-toolbar.ql-snow": {
            p: "0px !important",
            m: "0px !important",
            borderTop: "1px solid #E3E3E3",
            borderBottom: "1px solid #E3E3E3",
            borderLeft: "none",
            borderRight: "none",
          },
          "& .ql-editor a": {
            color: "blue",
            cursor: "pointer",
            textDecoration: "underline", // Optional: underline links
          },
          "& .ql-snow.ql-toolbar button": {
            borderRadius: "6px",
            width: "32px",
            height: "32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "7px",
          },

          "& .ql-snow.ql-toolbar button.ql-active,.ql-snow .ql-toolbar button.ql-active,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item.ql-selected":
            {
              backgroundColor: "#EDEDED",
              color: "black",
            },
          "& .ql-snow.ql-toolbar.ql-stroke": {
            color: "black",
          },
          "& .ql-container": {
            border: "none !important",
            minHeight: 0,
            height: "auto", // Allow container to expand
          },
          "& .ql-container.ql-snow": {
            backgroundColor: "transparent",
            overflow: "scroll",
            height: " 100%",
            display: "flex",
            border: "none",
          },
          "& .ql-editor > p": {
            color: "#767B85",
          },
          "& .ql-editor.ql-blank::before": {
            paddingLeft: "16px",
          },
        }}
      >
        <div
          // @ts-ignore
          onBlur={() => onBlur()}
          id="quill-editor"
          style={{
            width: "100%",
            height: "100%",
            // maxHeight: "100px",
          }}
        >
          {props?.showToolbar && <QuillToolBar />}
          {props?.error && (
            <Typography
              pl="16px"
              mt="16px"
              variant="body-small"
              color={"error"}
            >
              {props?.errorMessage
                ? props?.errorMessage
                : "This is required field"}
            </Typography>
          )}

          <ReactQuill
            ref={customRef}
            style={{
              height: "100%",
              overflow: "scroll",
              // border: props.error ? "1px solid #CE293A" : "1px solid #d9d9d9",
              // whiteSpace: "pre-line",
            }}
            theme="snow"
            value={props.value}
            onChange={onChangeHandler}
            placeholder={`${props.placeholder} ${props.isRequired ? "*" : ""}`}
            modules={{
              toolbar: props.showToolbar
                ? {
                    container: "#quill-toolbar",
                  }
                : false,
            }}
            {...props}
          />
        </div>
      </Box>
    );
  },
);

export default CustomQuillEditor;
